<template>
  <div>
    <div class="flex justify-content-between w100 colorFondo">
      <div class="w100 flex flex-column">
        <div v-if="editor" class="menuWord">
          <DropdownForInserts
            :data="data"
            :notInclude="notInclude"
            @insert="(value) => insertSuggestion(value)"
          />

          <Dropdown
            v-if="enableFontSize"
            v-model="fontSize"
            class="ml-2"
            :options="fontSizes"
            optionLabel="name"
            optionValue="value"
            placeholder="Tamaño de tipografia"
          />
          <button
            @click="editor.chain().focus().toggleBold().run()"
            :class="{ icon: true, 'is-active': editor.isActive('bold') }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-bold"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().toggleItalic().run()"
            :class="{ icon: true, 'is-active': editor.isActive('italic') }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-italic"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().toggleUnderline().run()"
            :class="{ icon: true, 'is-active': editor.isActive('underline') }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-underline"
              ></use>
            </svg>
          </button>

          <input
                type="color"
                value="#000000"
                title="Color de texto"
                class="text-color-picker"
                @input="editor.chain().focus().setColor($event.target.value).run()"
              />

          <button @click="editor.chain().focus().unsetAllMarks().run()" class="icon">
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-format-clear"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().setTextAlign('left').run()"
            :class="{ icon: true, 'is-active': editor.isActive({ textAlign: 'left' }) }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-align-left"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().setTextAlign('center').run()"
            :class="{ icon: true, 'is-active': editor.isActive({ textAlign: 'center' }) }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-align-center"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().setTextAlign('right').run()"
            :class="{ icon: true, 'is-active': editor.isActive({ textAlign: 'right' }) }"
            test-id="buttonRight"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-align-right"
              ></use>
            </svg>
          </button>
          <button
            @click="editor.chain().focus().setTextAlign('justify').run()"
            :class="{
              icon: true,
              'is-active': editor.isActive({ textAlign: 'justify' }),
            }"
          >
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-align-justify"
              ></use>
            </svg>
          </button>
          <button @click="editor.chain().focus().undo().run()" class="icon">
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-arrow-go-back-line"
              ></use>
            </svg>
          </button>
          <button @click="editor.chain().focus().redo().run()" class="icon">
            <svg data-v-1782ed7d="" class="remix">
              <use
                data-v-1782ed7d=""
                xlink:href="/assets/remixicon.symbol.f09b1c74.svg#ri-arrow-go-forward-line"
              ></use>
            </svg>
          </button>

          <button
            @click="
              editor
                .chain()
                .focus()
                .setID('master-sangria', editor.getAttributes('paragraph'))
                .run();
              setSangria();
            "
            :class="{ icon: true, 'is-active': isActivePropio('master-sangria') }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M4.929 13.207l2.121 2.121 1.414-1.414-2.12-2.121 2.12-2.121 2.829 2.828 1.414-1.414L9.88 8.257 12 6.136l2.121 2.121 1.415-1.414-2.122-2.121 2.829-2.829a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.414l3.536-3.536z"
              />
            </svg>
          </button>
          <Button
            @click="
              editor.chain().focus().setClass('sangria', editor.getAttributes('paragraph')).run()
            "
            :class="{ 'mr-3 p-button-outlined': true, 'is-active': isActivePropio('sangria') }"
            label="Sangria"
            test-id="buttonSangria"
          />
        </div>
        <div class="gradient-div"></div>
        <div class="editor-page">
          <div class="zoom" :style="'transform: scale(' + zoom + ');'">
            <div class="regla-parent" test-id="reglaParent">
              <div class="regla margin-paper" ref="reglaRef" :style="`width: ${widthEditor}mm;`">
                <Slider class="slider" v-model="sangria" :max="widthEditorPX" />
              </div>
            </div>
            <div ref="paperRef" class="paper">
              <editor-content
                class="editor editorWord margin-paper"
                :style="`--text-indent: ${sangria}px; width: ${widthEditor}mm;`"
                :editor="editor"
                :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>
      <form
        method="POST"
        id="pdf"
        target="print_iframe"
        style="display: none"
        :enctype="enctype"
        :action="action_post"
      >
        <textarea name="codigo" id="codigo" cols="30" rows="10" v-model="allHtml"></textarea>
        <textarea name="params" id="params" cols="30" rows="10" v-model="paramsPDF"></textarea>
        <input v-if="token_local != ''" type="hidden" name="token" :value="token_local" />
      </form>
    </div>
    <div class="parentMS">
      <div ref="masterSangriaRef" class="masterSangria"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import tippy from "tippy.js";
import { Editor, EditorContent, VueRenderer } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Heading from "@tiptap/extension-heading";
import Text from "@tiptap/extension-text";
import TextAlign from "@tiptap/extension-text-align";
import Bold from "@tiptap/extension-bold";
import Underline from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import Slider from "primevue/slider";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import DropdownForInserts from "@/components/DropdownForInserts";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useOfflineCompat } from "@/composables/useOfflineCompat";
import EditorCommands from "./EditorCommands";
import EditorCommandsList from "./EditorCommandsList";
import {
  lineHeight,
  masterClass,
  masterID,
  textIndent,
  FontSize,
  // color,
} from "./stylefunctionsEditorWord";
import Color from "@tiptap/extension-color";

const props = defineProps({
  enableFontSize: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: "",
  },
  preview: {
    type: Boolean,
    default: false,
  },
  // eslint-disable-next-line vue/no-unused-properties
  suggestions: {
    type: Array,
    default: () => [],
  },
  // eslint-disable-next-line vue/no-unused-properties
  insert: {
    type: Function,
    default: null,
  },
  notInclude: {
    type: Array,
    default: () => [],
  },
  data: {
    type: [Object, Array],
    default: () => ({}),
  },
});

const emit = defineEmits(["showPreview", "loading"]);

const store = useStoreCompat();
const offline = useOfflineCompat();
const instance = getCurrentInstance();

const reglaRef = ref(null);
const paperRef = ref(null);
const masterSangriaRef = ref(null);

const zoom = ref(1);
const enctype = ref("text/plain");
const token_local = ref("");
const action_post = ref("");
const editor = ref(null);
const code = ref("");
const allHtml = ref("");
const paramsPDF = ref("{}");
const pageSize = ref("Legal");
const sangria = ref(0);
const toPrint = ref(false);
const widthEditor = ref(170);
const widthEditorPX = ref(643);
const fontSizes = ref([
  { name: "Carátulas Tamaño 1", value: "1.84em" },
  { name: "Carátulas Tamaño 2", value: "1.58em" },
  { name: "Carátulas Tamaño 3", value: "1.32em" },
  { name: "Diligencias Tamaño 1", value: "1.21em" },
  { name: "Diligencias Tamaño 2", value: "1em" },
  { name: "Diligencias Tamaño 3", value: "0.87em" },
]);

const deleteWords = (actuationName) => {
  const phrasesToRemove = ["por oficio", "oficio", "por denuncia", "denuncia"];
  let result = actuationName;
  let lowercaseText = result.toLowerCase();
  phrasesToRemove.forEach((phrase) => {
    const lowercasePhrase = phrase.toLowerCase();
    let position = lowercaseText.indexOf(lowercasePhrase);
    while (position !== -1) {
      result = result.substring(0, position) + result.substring(position + phrase.length);
      lowercaseText =
        lowercaseText.substring(0, position) + lowercaseText.substring(position + phrase.length);
      position = lowercaseText.indexOf(lowercasePhrase);
    }
  });
  result = result.replace(/\s+/g, " ").trim();
  return result;
};

const station = computed(() => {
  if (store.state.user.userdata.claseDeUsuario === "UsuarioFiscal") {
    return deleteWords(store.state.sumario.tiposumarioID);
  }
  return store.state.user.userdata.dependenciaHeader;
});

const fontSize = computed({
  get() {
    return editor.value.getAttributes("textStyle").fontSize;
  },
  set(v) {
    editor.value.chain().focus().setFontSize(v).run();
  },
});

const setSangria = () =>
  new Promise((resolve) => {
    if (document.querySelector("#master-sangria")) {
      masterSangriaRef.value.innerHTML = document.querySelector("#master-sangria").innerHTML;
      masterSangriaRef.value.setAttribute(
        "style",
        document.querySelector("#master-sangria").getAttribute("style")
      );
      sangria.value = widthEditorPX.value - masterSangriaRef.value.offsetWidth;
    }
    resolve();
  });

const fSubmit = () => {
  const config = {
    "margin-top": 12.5,
    "margin-bottom": 34.7,
    "margin-left": 35,
    "margin-right": 11,
    pageSize: "Legal",
    sangria: sangria.value,
    station: station.value,
  };

  paramsPDF.value = JSON.stringify(config);
  action_post.value = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/print/`;
  enctype.value = "text/plain";

  if (offline.offlineServer) {
    enctype.value = "application/x-www-form-urlencoded";
    action_post.value = `${offline.offlineServer}/api/pdf/`;
    token_local.value = offline.activeJWT;
  }

  setTimeout(() => {
    if (document.getElementById("pdf") != null) {
      document.getElementById("pdf").submit();
    }
    emit("loading", false);
  }, 200);
};

const codePrint = computed({
  get() {
    return allHtml.value;
  },
  set(value) {
    allHtml.value =
      props.preview === true ? value : code.value.getCode(value, station.value, sangria.value);

    if (!toPrint.value) {
      setTimeout(() => {
        setSangria();
      }, 100);
    }
    toPrint.value = false;
  },
});

const insertSuggestion = (raw) => {
  const value = typeof raw === "number" ? raw.toString() : raw;
  editor.value.commands.insertContent(value);
  editor.value.commands.focus();
};

const showPreview = () => {
  emit("showPreview");
  toPrint.value = true;
  // eslint-disable-next-line no-use-before-define
  print();
};

const loadVariables = (caratula) => {
  const transaction = editor.value.state.tr.insertText(caratula);
  editor.value.view.dispatch(transaction);
};

const isActivePropio = (dato) => {
  const atributos = editor.value.getAttributes("paragraph");
  if (dato === "master-sangria") {
    return atributos.masterID.masterID === dato;
  }
  if (dato === "sangria") {
    return atributos.masterClass.masterClass === dato;
  }
  return false;
};

const setCode = (docu) => {
  const re = /\[object Object\]/g;

  if (props.preview === true) {
    codePrint.value = docu;
    setTimeout(() => {
      fSubmit();
    }, 100);
    return;
  }

  if (docu.html !== undefined) {
    code.value = docu;
    // eslint-disable-next-line no-param-reassign
    docu.html = docu.html.replace(re, "");
    codePrint.value = docu.html;

    const isSame = editor.value.getHTML() === docu.html;
    if (isSame) return;
    editor.value.commands.setContent(docu.html, false);
  } else {
    code.value = docu;
    const isSame = editor.value.getHTML() === docu.doc.documento;
    if (isSame) return;
    // eslint-disable-next-line no-param-reassign
    docu.doc.documento = docu.doc.documento.replace(re, "");
    editor.value.commands.setContent(docu.doc.documento, false);
  }
};

const setPageSize = (newPageSize) =>
  new Promise((resolve) => {
    if (newPageSize) pageSize.value = newPageSize;
    if (pageSize.value === "legal") {
      widthEditor.value = 170;
    } else if (pageSize.value === "A4") {
      widthEditor.value = 830;
    }
    resolve();
  });

const print = async (cod = false, newPageSize) => {
  await setPageSize(newPageSize);
  return new Promise((resolve) => {
    if (cod !== false) {
      codePrint.value = cod;
    } else {
      codePrint.value = editor.value.getHTML();
    }

    setTimeout(() => {
      fSubmit();
      resolve(codePrint.value);
    }, 200);
  });
};

const setSangriaInt = (v) => {
  if (Number.isInteger(v)) sangria.value = v;
};

const getSangria = () => parseInt(sangria.value, 10);

const docuHtml = () => editor.value.getHTML();

onMounted(() => {
  widthEditorPX.value = reglaRef.value.clientWidth;
  if (props.preview !== true) {
    editor.value = new Editor({
      editorProps: {
        attributes: {
          class: "master-sangria",
        },
      },
      extensions: [
        StarterKit,
        Document,
        Paragraph,
        Text,
        Bold,
        TextStyle,
        lineHeight,
        FontSize,
        Underline,
        TaskList,
        TaskItem,
        Color,
        masterClass,
        masterID,
        textIndent,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell,
        Heading,
        TextAlign.configure({
          types: ["heading", "paragraph"],
        }),
        EditorCommands.configure({
          suggestion: {
            items: (query) =>
              [
                {
                  title: "H1",
                  command: ({ editor: ed, range }) => {
                    ed.chain().focus().deleteRange(range).setNode("heading", { level: 1 }).run();
                  },
                },
                {
                  title: "H2",
                  command: ({ editor: ed, range }) => {
                    ed.chain().focus().deleteRange(range).setNode("heading", { level: 2 }).run();
                  },
                },
                {
                  title: "bold",
                  command: ({ editor: ed, range }) => {
                    ed.chain().focus().deleteRange(range).setMark("bold").run();
                  },
                },
                {
                  title: "italic",
                  command: ({ editor: ed, range }) => {
                    ed.chain().focus().deleteRange(range).setMark("italic").run();
                  },
                },
              ]
                .filter((item) => item.title.toLowerCase().startsWith(query.toLowerCase()))
                .slice(0, 10),
            render: () => {
              let component;
              let popup;
              return {
                onStart: (rendererProps) => {
                  component = new VueRenderer(EditorCommandsList, {
                    parent: instance.proxy,
                    propsData: rendererProps,
                  });
                  popup = tippy("body", {
                    getReferenceClientRect: rendererProps.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: "manual",
                    placement: "bottom-start",
                  });
                },
                onUpdate(rendererProps) {
                  component.updateProps(rendererProps);
                  popup[0].setProps({
                    getReferenceClientRect: rendererProps.clientRect,
                  });
                },
                onKeyDown(rendererProps) {
                  return component.ref?.onKeyDown(rendererProps);
                },
                onExit() {
                  popup[0].destroy();
                  component.destroy();
                },
              };
            },
          },
        }),
      ],
      injectCSS: true,
      injectNonce: true,
      content: props.value,
    });

    editor.value.on("update", () => {
      setSangria();
    });
  }
});

onBeforeUnmount(() => {
  editor.value?.destroy();
});

defineExpose({
  setCode,
  docuHtml,
  getSangria,
  setSangriaInt,
  print,
  loadVariables,
  showPreview,
});
</script>

<style scoped vars>
.parentMS {
  font-size: 14pt;
  opacity: 0;
  position: absolute;
  top: -100px;
  position: absolute;
  font-family: "Times New Roman", Times, serif;
  color: red;
}

/deep/ .ProseMirror {
  font-size: 14pt;
  font-family: "Times New Roman", Times, serif;
}
/deep/ .ProseMirror * {
  font-family: "Times New Roman", Times, serif;
  text-rendering: geometricPrecision;
}
/deep/ .ProseMirror .sangria {
  text-indent: var(--text-indent) !important;
}
/deep/ .p-tieredmenu {
  width: auto !important;
}
.colorFondo {
  background: #ffffff;
  justify-content: center;
}
.regla-parent {
  width: 216mm;
  background: rgb(243, 243, 243);
  border-bottom: 1px solid #0d0d0d;
  padding: 10px 0;
  margin-bottom: 20px;
}
.regla-parent .regla {
  height: 20px;
  display: flex;
  align-items: center;
}
.regla-parent .regla .slider {
  width: 100%;
}
.editorWord * {
  font-family: "Times New Roman", Times, serif;
}
.menuWord {
  justify-content: center;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  flex-wrap: wrap;
  padding: 0.25rem;
}
.menuWord > button.icon {
  width: 40px;
  height: 40px;
  color: #0d0d0d;
  border: none;
  background-color: transparent;
  padding: 0.25rem;
  cursor: pointer;
  margin-right: 0.25rem;
}
.menuWord > button.icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
.is-active {
  color: red !important;
}
.zoom {
}
.gradient-div {
  display: block;
  height: 5px;
  width: 100%;

  background: linear-gradient(to bottom, rgb(184, 184, 184), rgb(243, 243, 243));
}
.editor-page {
  position: relative;
  overflow: auto;
  padding: 10px 0 20px;
  display: flex;
  justify-content: center;
  z-index: 0;
  background-color: rgb(243, 243, 243);
}
.paper {
  position: relative;
  background: #ffffff;
  padding: 47.21px 0 20px 0px;
  outline: 1px solid #ababab;
  width: 216mm;
  min-height: 1344px;
}
.editor {
  background: #ffffff;

  margin-top: 0;
  margin-bottom: 130.81;
  font-size: 20px;
}
/deep/ .ProseMirror > * {
  font-family: "Times New Roman", Times, serif !important;
  text-rendering: geometricPrecision;
}
.margin-paper {
  margin-right: 41.47px;
  margin-left: 132.19px;
}

.text-color-picker {
  width: 40px;
  height: 40px;
  padding: 4px;
  margin-right: 0.25rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
</style>
